<template>
  <div class="form-page">
    <div class="preview-tips" v-if="mode === 'preview'">
      此页面仅供预览效果，请勿转发投放！
    </div>
    <div class="top-wrap">
      <img class="banner" :src="formConfig.cover" />
      <p class="title">{{ formConfig.title }}</p>
      <div class="desc" v-html="$filters.proxyWeixinImage(formConfig.intro)"></div>
    </div>
    <div class="form-wrap">
      <template v-if="isSmsQuotaEnough && formItemsFilter?.length && isInit">
        <div
          v-for="(formItem) in formItemsFilter" 
          :key="formItem.id"
          class="form-item">
          <FormItem 
            v-if="showFormItem(formItem)"
            ref="formItemRef"
            :item="formItem" 
            :submitValues="submitValues"
            :readonly="formReadonly"
            @val-change="onValueChange($event, formItem.id)"
          />
        </div>
      </template>
      <div
        v-if="isSmsQuotaEnough && isInit && showTermsSelectAll"
        class="terms-select-all"
      >
        <van-checkbox
          v-model="termsSelectAllChecked"
          shape="square"
          icon-size="16px"
          :checked-color="formConfig.theme_color"
          :disabled="formReadonly"
        >我已阅读并同意以上全部条款。</van-checkbox>
      </div>
      <div class="no-data-tips" v-if="!isSmsQuotaEnough">
        短信余额不足，暂不可填写表单
      </div>
      <div class="no-data-tips" v-if="!formItemsFilter?.length">
        暂无数据
      </div>
      <div
        v-if="!isModi && isViewSubmit && formConfig.enable_modify" 
        class="modi-button"
        @click="isModi = true"
      >修改提交内容</div>
      <div
        v-if="isModi" 
        class="modi-button" 
        :class="{'disabled': !isSmsQuotaEnough || !formItemsFilter?.length}" 
        @click="submitHandle('modi')"
      >保存修改</div>
      <div
        v-if="!isReadonly && (formConfig.enable_multiple_submit || !hasSubmit)" 
        class="submit-button" 
        :class="{'disabled': !isSmsQuotaEnough || !formItemsFilter?.length}" 
        @click="submitHandle()"
      >提交</div>
      <div
        v-if="(isReadonly && isViewSubmit) || (!formConfig.enable_multiple_submit && hasSubmit)"
        class="view-result"
        @click="toViewResult()"
      >查看提交结果</div>
      <div class="submit-tips" v-if="isReadonly">
        您已完成提交，可在上方查看结果。
      </div>
      <SubmitDetailBtn v-if="!isReadonly && formConfig.enable_multiple_submit" />
    </div>
    <PhoneVerifyCodePopup 
      ref="PhoneVerifyCodePopupRef"
      @ok="onPhoneVerifyCodeOk($event)"
    />
  </div>
</template>

<script>
import { api } from "@/utils/fetch.js";
import { getQueryString, isWeixin, verifyMethods } from '@/utils/tools.js';
import { checkPhoneHasSame } from '@/utils/helper.js';
import { Checkbox, Icon, Toast } from "vant";
import getUnixTime from 'date-fns/fp/getUnixTime';
import startOfDay from 'date-fns/startOfDay';
import FormItem from './FormItem';
import _ from 'lodash';
import PhoneVerifyCodePopup from './comps/PhoneVerifyCodePopup.vue';
import SubmitDetailBtn from './comps/SubmitDetailBtn.vue';


const emailCommonSuffixList = [
  'qq.com',
  '163.com',
  '126.com',
  'sohu.com',
  'sina.com',
  'foxmail.com',
  'yeah.net',
  'yahoo.com.cn',
  'aliyun.com',
  'outlook.com',
  'hotmail.com',
  'gmail.com',
  '21cn.com',
  '263.com',
  '188.com',
  '189.cn',
  '139.com',
  'sina.cn',
  '163.net',
  '163vip.com',
  'vip.tom.com',
  'tom.com',
];

export default {
  data() {
    return {
      isInit: false,
      isSubmit: false,
      isSmsQuotaEnough: true,
      phoneCode: '',
      mode: getQueryString('mode'),
      isReadonly: !!getQueryString('readonly'),
      isViewSubmit: !!getQueryString('view_submit'),
      isSummary: !!getQueryString('summary'),
      hasSubmit: false,
      isModi: false,
      submitValues: {
      },
      valuesForFilter: {
      },
      valuesForFilterTimer: null

    };
  },
  computed: {
    formConfig() {
      if (this.$store.state.formConfig?.title) {
        document.title = this.$store.state.formConfig.title;
      }
      return this.$store.state.formConfig;
    },
    formItems() {
      return this.$store.state.formItems;
    },
    formItemsFilter() {
      const tmpArr = [];
      this.formItems?.map(v => {
        if (v.condition?.field_id) {
          let hasOp = false;
          let value = this.valuesForFilter[v.condition.field_id]?.value;
          if (value) {
            if (v?.condition?.values?.[0] === 'is_email_common_suffix') {
              emailCommonSuffixList?.map(suffix => {
                if (verifyMethods.email(value) && value.split('@')[1] === suffix) {
                  hasOp = true;
                }
              });
            }
            else if (v?.condition?.values?.[0] === 'not_email_common_suffix') {
              let tmpFlag = false;
              emailCommonSuffixList?.map(suffix => {
                if (value.split('@')[1] === suffix) {
                  tmpFlag = true;
                }
              });
              hasOp = verifyMethods.email(value) && !tmpFlag;
            }
            else if (
              typeof value === 'string'
              && v.condition.values.indexOf(value) >= 0
            ) {
              hasOp = true;
            }
            else if (
              typeof value === 'object'
            ) {
              value.map(v2 => {
                if (v.condition.values.indexOf(v2) >= 0) {
                  hasOp = true;
                }
              });
            }
          }
          if (hasOp) {
            tmpArr.push(v);
          }
        } else {
          tmpArr.push(v);
        }
      });
      return tmpArr;
    },
    requiredCheckboxItems() {
      return this.formItemsFilter.filter(v => {
        return !!v.id && v.type === 'checkbox' && (v.required === 1 || v.required === true) && this.showFormItem(v);
      });
    },
    showTermsSelectAll() {
      return this.requiredCheckboxItems.length >= 2;
    },
    termsSelectAllChecked: {
      get() {
        return this.showTermsSelectAll && this.requiredCheckboxItems.every(v => !!this.submitValues[v.id]?.value);
      },
      set(checked) {
        this.onTermsSelectAllChange(checked);
      }
    },
    formReadonly() {
      return this.isSummary || (this.isReadonly && !this.isModi) || (!this.formConfig.enable_multiple_submit && this.hasSubmit);
    }
  },
  
  components: {
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    FormItem,
    PhoneVerifyCodePopup,
    SubmitDetailBtn
  },
  methods: {
    onValueChange(e, id) {
      this.submitValues[id] = e;
      const newValues = {};
      let changeType = '';
      this.formItemsFilter.map(v => {
        if (this.submitValues[v.id]) {
          newValues[v.id] = _.cloneDeep(this.submitValues[v.id]);
        }
        if (v.id === id) {
          changeType = v.type;
        }
      });
      this.submitValues = newValues;
      clearTimeout(this.valuesForFilterTimer);
      this.valuesForFilterTimer = setTimeout(() => {
        this.valuesForFilter = _.cloneDeep(newValues);
      }, changeType === 'email' ? 600 : 0);
      sessionStorage.setItem(`VALUE_CACHE_FORM_${this.$route.query.form_id}`, JSON.stringify(this.submitValues));
    },
    onTermsSelectAllChange(checked) {
      this.requiredCheckboxItems.forEach(item => {
        this.onValueChange({ value: checked ? 1 : 0 }, item.id);
      });
    },
    viewForm() {
      api.ViewForm({ id: getQueryString('form_id'), channel_id: getQueryString('channel_id') }).then((res) => {
      }).catch((e) => {
        
      });
    },
    showFormItem(formItem) {
      if (formItem.type === 'invite_code' && formItem.only_url) {
        return false;
      }
      return true;
    },
    updateFormVal() {
      let isPass = true;
      _.forIn(this.$refs['formItemRef'], (item, index) => {
        if (!item?.verificate()) {
          if (isPass) {
            const scrollTop = item?.$el?.offsetTop > 20 ? item?.$el?.offsetTop - 20 : 0;
            document.documentElement.scrollTop = scrollTop;
            if (!document.documentElement.scrollTop) {
              document.body.scrollTop = scrollTop;
            }
          }
          isPass = false;
        }
      });
      return isPass;
    },
    checkSmsQuota() {
      const index = this.formItems.findIndex(v => v.type === 'phone' && v.phone_verify === 'code');
      if(index >= 0) {
        api.CheckSmsQuota().then((res) => {
          this.isSmsQuotaEnough = res;
        }).catch((e) => {
        
        });
      }
    },
    phoneVerifyCode() {
      const index = this.formItemsFilter.findIndex(v => v.type === 'phone' && v.phone_verify === 'code');
      if(index >= 0) {
        if (this.submitValues[this.formItemsFilter[index].id] && this.submitValues[this.formItemsFilter[index].id]?.value && !this.phoneCode) {
          this.$refs['PhoneVerifyCodePopupRef'].open(this.submitValues[this.formItemsFilter[index].id].value, this.formItemsFilter[index]);
          return false;
        }
      }
      return true;
    },
    onPhoneVerifyCodeOk(code) {
      this.phoneCode = code;
      this.submitHandle();
    },
    async uniquePhoneCheck() {
      let isPass = true;
      for (let i = 0; i < this.formItemsFilter.length; i ++) {
        const item = this.formItemsFilter[i];
        const submitValuePhone = this.submitValues?.[item.id]?.value;
        if (item.type === 'phone' && item.unique && item.phone_verify !== 'code' && submitValuePhone) {
          const hasSamePhone = await checkPhoneHasSame(submitValuePhone, item);
          if (hasSamePhone) {
            isPass = false;
            Toast(`已存在该${item.name}的提交记录`);
          }
        }
      }
      return isPass;
      
    },
    async submitHandle(type) {
      if (this.isSubmit) {
        return;
      }
      if (!this.updateFormVal()) {
        return;
      }
      // 手机验证码
      if (!this.phoneVerifyCode()) {
        return;
      }
      // 手机号唯一性
      if (!await this.uniquePhoneCheck()) {
        return;
      }
      if (this.mode === 'preview') {
        this.afterSubmit(this.formConfig.result_type, this.formConfig.result_param);
      } else {
        const submitData = {};
        const inviteStr = getQueryString('invite');
        this.formItemsFilter.map(v => {
          if (v.type === 'invite_code' && v.only_url && inviteStr) {
            submitData[v.id] = {
              value: inviteStr
            };
          } else {
            if (this.submitValues[v.id]) {
              submitData[v.id] = this.submitValues[v.id];
            }
          }
        });
        

        if (type === 'modi') {
          const submitForm = {
            id: this.$store.state.submitDetail.id,
            data: submitData
          }; 
          this.isSubmit = true;
          api.Modify(submitForm).then((res) => {
            Toast('您的修改已保存成功');
            sessionStorage.removeItem(`VALUE_CACHE_FORM_${this.$route.query.form_id}`);
            this.isSubmit = false;
            this.isModi = false;
          }).catch((e) => {
            this.isSubmit = false;
          });
        } else {
          const submitForm = {
            form_id: this.$route.query.form_id,
            channel_id: this.$route.query.channel_id,
            data: submitData
          }; 
          this.isSubmit = true;
          api.Submit(submitForm).then((res) => {
            this.afterSubmit(res.result_type, res.result_param, res.submit_id);
            Toast('提交成功');
            sessionStorage.removeItem(`VALUE_CACHE_FORM_${this.$route.query.form_id}`);
            this.isSubmit = false;
          }).catch((e) => {
            this.isSubmit = false;
          });
        }
      }
    },
    toViewResult() {
      api.CheckSubmit({ 
        id: this.$route.query.form_id
      }, true).then((res) => {
        this.afterSubmit(res.result_type, res.result_param, this.$route.query.submit_id || res.id);
      }).catch((e) => {
        
      });
      
    },
    async getSubmitDetail() {
      try {
        await this.$store.dispatch('getSubmitDetail', { 
          form_id: this.$route.query.form_id,
          submit_id: this.$route.query.submit_id,
        });
        this.submitValues = _.cloneDeep(this.$store.state.submitDetail.data);
        this.valuesForFilter = _.cloneDeep(this.submitValues);
      } catch (e) {
        if (e.err_code === 10005) {
          this.isReadonly = false;
          this.$router.replace({
            path: '/index',
            query: {
              form_id: this.$route.query.form_id,
              channel_id: this.$route.query.channel_id,
              invite: this.$route.query.invite
            }
          });
        }
      }
    },
    async afterSubmit(result_type, result_param, submit_id) {
      if (!result_type) {
        Toast('暂无设置提交结果页');
        return;
      }
      const routeQuery = _.cloneDeep(this.$route.query);
      delete routeQuery.summary;
      delete routeQuery.readonly;
      delete routeQuery.view_submit;
      delete routeQuery.submit_id;
      delete routeQuery._t;
      if (result_type === 'redirect') {
        window.location.replace(result_param);
      }
      else if (result_type === 'page') {
        sessionStorage.setItem(`RESULT_PARAM_CACHE_FORM_${this.$route.query.form_id}`, result_param);
        delete routeQuery.mode;
        this.$router.replace({
          path: '/success',
          query: {
            ...routeQuery,
            submit_id: submit_id || ''
          }
        });
      }
      else if (result_type === 'summary') {
        this.$router.replace({
          path: '/index',
          query: {
            ...routeQuery,
            readonly: 1,
            summary: 1,
            submit_id: submit_id || '',
            _t: new Date().getTime()
          }
        });
      }
    },
    getCache() {
      const cache = sessionStorage.getItem(`VALUE_CACHE_FORM_${this.$route.query.form_id}`);
      let tmpObj = {};
      if (cache) {
        try {
          tmpObj = JSON.parse(cache);
        } catch(e) {
          console.log('解析value cache失败');
        }
      }
      this.submitValues = tmpObj;
      this.valuesForFilter = _.cloneDeep(this.submitValues);
    },
    inWeixin() {
      if (!isWeixin()) {
        this.$router.push({
          path: '/noweixin',
          query: this.$route.query
        });
        return false;
      }
      return true;
    },
    inPermitTime() {
      let flag = true;
      const curTime = getUnixTime(new Date());

      // console.log('现在时间：', format(curTime * 1000, 'yyyy-MM-dd HH:mm:ss'));
      if (this.formConfig.enable_absolute_limit_time) {
        // console.log('absolute_limit_time_start：', format(this.formConfig.absolute_limit_time_start * 1000, 'yyyy-MM-dd HH:mm:ss'));
        // console.log('absolute_limit_time_end：', format(this.formConfig.absolute_limit_time_end * 1000, 'yyyy-MM-dd HH:mm:ss'));
        if (
          curTime < this.formConfig.absolute_limit_time_start
          || curTime > this.formConfig.absolute_limit_time_end
        ) {
          flag = false;
        }
      }
      if (this.formConfig.enable_daily_limit_time) {
        const dayStartTime = getUnixTime(startOfDay(new Date()));
        // console.log('daily_limit_time_start：', format((dayStartTime + this.formConfig.daily_limit_time_start) * 1000, 'yyyy-MM-dd HH:mm:ss'));
        // console.log('daily_limit_time_end：', format((dayStartTime + this.formConfig.daily_limit_time_end) * 1000, 'yyyy-MM-dd HH:mm:ss'));
        if (
          curTime < (dayStartTime + this.formConfig.daily_limit_time_start)
          || curTime > (dayStartTime + this.formConfig.daily_limit_time_end)
        ) {
          flag = false;
        }
      }
      if (!flag) {
        this.$router.push({
          path: '/nopermit',
          query: {
            ...this.$route.query,
            type: 'not_in_time'
          }
        });
      }
      return flag;
    },
  },
  created() {
    this.getCache();
  },
  async mounted() {
    if (!this.inWeixin()) {
      // 不在微信环境的
      return;
    }
    if (this.mode === 'preview') {
      // 预览
      this.isInit = true;
      return;
    }
    // 浏览数据打点
    this.viewForm();
    if (!this.formConfig.open) {
      // 如果表单未开启
      this.$router.push({
        path: '/nopermit',
        query: {
          ...this.$route.query,
          type: 'not_open'
        }
      }); 
      return;
    }
    if (!this.inPermitTime()) {
      // 如果不在允许填写的时间范围
      return;
    }
    // 获取表单项配置
    await this.$store.dispatch('getFormFields', { id: getQueryString('form_id') });

    if (getQueryString('view_submit') === '1') {
      // 查看提交结果
      await this.getSubmitDetail();
    } 
    else if (getQueryString('summary') === '1') {
      this.isReadonly = true;
      await this.getSubmitDetail();
      this.$store.dispatch('countFormSubmit', this.submitValues);
    }   
    else {
      // 编辑状态
      this.checkSmsQuota();
      try {
        await api.CheckSubmit({ 
          id: this.$route.query.form_id
        }, true).then((res) => {
          this.hasSubmit = !!res.id;
        }).catch((e) => {
        });
      } catch (e) { console.error(e); }
    }

    this.$nextTick(async () => {
      // 开始渲染页面
      this.isInit = true;
    });
  }
};
</script>

<style lang="less" scoped>
@import (reference) '@/assets/less/common.less';

.form-page {
  position: relative;

  .preview-tips {
    background-color: #fff7e7;
    color: #FAAD14;
    font-size: @font-size-4;
    text-align: center;
    line-height: 42px;
  }
  .top-wrap {
    border-bottom: solid 5px #ecf1f3;
    .banner {
      width: 100%;
      display: block;
    }
    .title {
      font-weight: 700;
      font-size: @font-size-1;
      line-height: 25px;
      color: @title-color;
      padding: 24px 0 14px 0;
      text-align: center;
    }
    .desc {
      font-size: @font-size-3;
      line-height: 20px;
      color: @desc-color-1;
      padding: 0 20px 25px 20px;
      /deep/ img {
        max-width: 100%;
      }
    }
  }
  .form-wrap {
    padding: 24px 20px;
    
  }
  .no-data-tips {
    text-align: center;
    font-size: @font-size-3;
    color: @desc-color-2;
    line-height: 60px;
  }
  .terms-select-all {
    --van-checkbox-border-color: #000000;
    margin: -8px 0 32px;
    padding-top: 16px;
    border-top: 1px solid #E9E9E9;
    /deep/ .van-checkbox {
      align-items: flex-start;
    }
    /deep/ .van-checkbox__icon {
      margin-top: 2px;
    }
    /deep/ .van-checkbox__label {
      flex: 1;
      min-width: 0;
      font-size: @font-size-4;
      line-height: 20px;
      color: @desc-color-1;
      overflow-wrap: anywhere;
      white-space: pre-line;
    }
  }

  .submit-button {
    .submit-button();
    margin-top: 32px;
  }
  .view-result {
    .submit-button();
    border: 1px solid #E9E9E9;
    background-color: #fff;
    color: @desc-color-1;
  }
  .modi-button {
    .submit-button();
  }
  .submit-tips {
    text-align: center;
    font-size: @font-size-3;
    color: @desc-color-2;
    margin-top: 10px;
  }
}
</style>
